import { aboutProducts } from '@/mocks/about';

export default function OfferingsSection() {
  return (
    <section className="w-full py-10 md:py-20 bg-background-200 relative overflow-hidden scroll-mt-20">
      <div className="absolute inset-0 pointer-events-none select-none" aria-hidden="true">
        <div className="w-12 h-12 flex items-center justify-center absolute top-10 left-[7%] opacity-[0.06] rotate-[15deg] animate-float">
          <i className="fa-solid fa-sparkles text-4xl text-foreground-950"></i>
        </div>
        <div className="w-14 h-14 flex items-center justify-center absolute top-20 right-[9%] opacity-[0.05] rotate-[-20deg] animate-drift" style={{ animationDelay: '0.9s' }}>
          <i className="fa-solid fa-star text-5xl text-foreground-950"></i>
        </div>
        <div className="w-10 h-10 flex items-center justify-center absolute bottom-16 left-[12%] opacity-[0.06] rotate-[30deg] animate-float" style={{ animationDelay: '1.8s' }}>
          <i className="fa-solid fa-sparkles text-3xl text-foreground-950"></i>
        </div>
        <div className="w-12 h-12 flex items-center justify-center absolute bottom-20 right-[14%] opacity-[0.05] rotate-[-35deg] animate-drift" style={{ animationDelay: '2.7s' }}>
          <i className="fa-solid fa-star text-4xl text-foreground-950"></i>
        </div>
      </div>

      <div className="max-w-6xl mx-auto px-4 md:px-8 relative z-10">
        <h2 className="text-center text-3xl md:text-4xl font-black text-primary-500 mb-3">What We Offer</h2>
        <p className="text-center text-foreground-700 text-base md:text-lg mb-8 md:mb-12 max-w-3xl mx-auto">
          From beautifully illustrated adventure books to personalized keepsakes, there's a magical
          Gracie & Lily story for every family.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {aboutProducts.map((product) => (
            <div
              key={product.title}
              className="bg-white/60 rounded-2xl p-5 md:p-6 flex flex-col gap-3 hover:scale-[1.02] transition-transform duration-300"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-100 text-primary-500">
                <i className={`fa-solid ${product.icon} text-xl`}></i>
              </div>
              <h3 className="text-lg font-extrabold text-primary-500">{product.title}</h3>
              <p className="text-foreground-700 text-sm leading-relaxed">{product.description}</p>
              <div className="flex flex-wrap gap-2 mt-1">
                {product.items.map((item) => (
                  <span
                    key={item}
                    className="bg-secondary-100 text-secondary-900 px-2.5 py-1 rounded-full text-xs font-semibold whitespace-nowrap"
                  >
                    {item}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>

        <p className="text-center text-foreground-700 text-sm md:text-base mt-8 md:mt-10 max-w-3xl mx-auto">
          Selected personalized books allow a child to become part of the story — including their
          name, appearance, location, and other story details.
        </p>
      </div>
    </section>
  );
}